module.exports = __webpack_public_path__ + "static/media/banner.0753a3b4.jpg";